module.exports = __webpack_public_path__ + "static/media/logoMemberLyfe.svg";